export default [
  {
    value: 'name',
    locale: 'objects.name',
  },
  {
    value: 'review',
    locale: 'objects.routing.chatGateways.messenger.whatsapp.review',
  },
  {
    value: 'number',
    locale: 'objects.routing.chatGateways.messenger.whatsapp.number',
  },
  {
    value: 'status',
    locale: 'objects.routing.chatGateways.messenger.whatsapp.status',
  },
  {
    value: 'subscription',
    locale: 'objects.enabled',
  },
];
